<template>
  <header class="header-navbar" :class="{'fixed-top' : $route.name !== 'ContactUs'}" style="width: 100%;"
          :style="[ $route.name !== 'ContactUs' ? 'background: #1a191d' : 'background: white']">
    <div class="nav container px-2">
      <a class="logo">
        <img alt="logo" class="img-fluid" src="@/assets/images/home/logo.png"/>
      </a>

      <div class="nav-links d-none d-xl-flex">
        <a href="/" class="header-link"><span :class="{'active-link' : $route.name === 'Home'}"></span>Home
        </a>
        <a href="/about-us" class="header-link"><span
            :class="{'active-link' : $route.name === 'AboutUs'}"></span>About us
        </a>
        <a href="/gv-learning" class="header-link"><span
            :class="{'active-link' : $route.name === 'GVLearning'}"></span>GV Learning
        </a>
        <a href="/gv-group" class="header-link"><span
            :class="{'active-link' : $route.name === 'GVGroup'}"></span>GV Group
        </a>
        <!--<a href="/membership-registration" class="header-link"><span
            :class="{'active-link' : $route.name === 'MembershipRegistration'}"></span>Membership Registration
        </a>-->
        <a href="/businesses-registration" class="header-link"><span
            :class="{'active-link' : $route.name === 'BusinessesRegistration'}"></span>GV Business
        </a>
        <a href="/store" class="header-link"><span
            :class="{'active-link' : $route.name === 'Store'}"></span>Store
        </a>
        <a href="/contact-us" class="header-link"><span
            :class="{'active-link' : $route.name === 'ContactUs'}"></span>Let's Talk
        </a>
      </div>
      <nav role="navigation" class="d-xxl-none d-xl-none">
        <div id="menuToggle">
          <input type="checkbox"/>
          <span></span>
          <span></span>
          <span></span>
          <ul id="menu">
            <a href="/" class="header-link">
              <li>Home</li>
            </a>
            <a href="/about-us" class="header-link">
              <li>About us</li>
            </a>

            <a href="/gv-learning" class="header-link">
              <li>GV Learning</li>
            </a>
            <a href="/gv-group" class="header-link">
              <li>GV Group</li>
            </a>
            <!--<a href="/membership-registration" class="header-link">
              <li>Membership Registration</li>
            </a>-->
            <a href="/businesses-registration" class="header-link">
              <li>GV Business</li>
            </a>
            <a href="/store" class="header-link">
              <li>Store</li>
            </a>
            <a href="/contact-us" class="header-link">
              <li>Let's Talk</li>
            </a>
          </ul>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {}
</script>
